import { ISelectOption, scheduling } from "lobbie";
import { useCallback } from "react";
import PatientSchedulingUserDetailsChildCard from "./PatientSchedulingUserDetailsChildCard";

interface IProps {
    options: ISelectOption[];
    children: scheduling.patient.IPatientDetailsChild[];
    selectedChildIndex: number | undefined;
    handleUpdate: (child: scheduling.patient.IPatientDetailsChild, index: number) => void;
    handleSelect: (index: number) => void;
}

const PatientSchedulingUserDetailsChildren: React.FC<IProps> = ({
    options,
    children,
    selectedChildIndex,
    handleUpdate,
    handleSelect,
}) => {
    const getChildOptionLabel = useCallback((child: scheduling.patient.IPatientDetailsChild) => {
        return (
            <div className="ellipses">
                <span>
                    &nbsp;{child.firstName} {child.lastName}
                </span>
            </div>
        );
    }, []);

    return (
        <>
            {children.map((child, index) => (
                <div className="row mb-3" key={`PatientSchedulingChildren-${index}`}>
                    <div className="col">
                        <PatientSchedulingUserDetailsChildCard
                            options={options}
                            label={getChildOptionLabel(child)}
                            child={child}
                            index={index}
                            selectedChildIndex={selectedChildIndex}
                            handleSavingNewChild={handleUpdate}
                            handleSelect={handleSelect}
                        />
                    </div>
                </div>
            ))}
        </>
    );
};
export default PatientSchedulingUserDetailsChildren;
